export default class CardEnum {
    static CARD_SHOW_TRACE = '[data-trigger="wpet-show-trace"]'
    static CARD_SHOW_TRACE_TOGGLE = '[data-trigger="wpet-show-trace-toggle"]'
}
